import { localized, msg, str } from "@lit/localize";
import { LitElement, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { getLocale } from "../locale";
import { assetPath } from "../utils";
import style from './cas-lang.scss';

/**
 * Language switch widget for CasBar.
 */

@customElement('cas-lang')
@localized()
export class CasLang extends LitElement {
    static override styles = style;

    /**
     * Language switch URL.
     */
    @property({ attribute: 'change-url' }) changeUrl = '';

    override render() {
        const otherLang = getLocale() == 'en' ? 'pl' : 'en';
        const changeMessage = msg(str`English version`, { desc: 'Title for language switch button' });
        const langImgSrc = assetPath(`assets/lang/${otherLang}.svg`);
        return html`
            <a id="langSwitch" href="${this.changeUrl}" title="${changeMessage}" lang="${otherLang}">
                <img src="${langImgSrc}" alt="${changeMessage}">
            </a>
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'cas-lang': CasLang,
    }
}
